const {
  NODE_ENV,
  REACT_APP_URL,
  REACT_APP_BASE_URL,
  REACT_APP_DASHBOARD_BACKEND_BASE_URL,
  REACT_APP_SEARCH_CREDENTIALS_KEY,
  REACT_APP_SESSION_COOKIE_DOMAIN,
  REACT_APP_LOGIN_URL,
  REACT_APP_PLATFORM_BACKEND_BASE_URL,
} = process.env;

export const SYSTEM = {
  ENV: NODE_ENV || "development",
  URL: REACT_APP_URL,
  SESSION_COOKIE_DOMAIN: REACT_APP_SESSION_COOKIE_DOMAIN,
  LOGIN_URL: REACT_APP_LOGIN_URL,
  BASE_URL: REACT_APP_BASE_URL || "./",
  DASHBOARD_BACKEND_BASE_URL:
    REACT_APP_DASHBOARD_BACKEND_BASE_URL || "https://apidb.geslub.cl",
  PLATFORM_BACKEND_BASE_URL:
    REACT_APP_PLATFORM_BACKEND_BASE_URL || "https://api.geslub.cl",
};

export const URL_SEARCH_CRYPT_KEYS = {
  CREDENTIAL: REACT_APP_SEARCH_CREDENTIALS_KEY || "myKey",
};

export const APIS = {
  AUTH_BASE_URL: REACT_APP_PLATFORM_BACKEND_BASE_URL || "http://localhost:3001",
  DASH_BASE_URL:
    REACT_APP_DASHBOARD_BACKEND_BASE_URL || "http://localhost:5000",
};
